module.exports = __webpack_public_path__ + "static/img/sign-e.da9200ee.png";